<template>
	<div>
		<information-card
			sub-title="Descripción"
			title="MODELO DIRECTRIZ"
			class='full-section-height'
		>
			<div slot="content">
				<div>
					<p>Este Modelo Directriz te servirá para clasificar los puestos de tu organización.</p>
                    <p>Es muy útil para asignar el nivel del puesto (mando alto, medio o bajo), para definir el rol, la titulación y experiencia elegibles así como el nivel de idiomas o número de puestos.</p>
                    <p>Si necesitas mayor información puedes acudir a nuestros tutoriales en la pestaña entrenamiento de la web praktiko.tech o enviar un email a: info@praktiko.tech </p>
				</div>
				<div class="message">
					RECUERDA: Antes de realizar alguna acción, actualiza la página para sincronizar cambios realizados desde otros dispositivos.
				</div>
			</div>
		</information-card>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { find, pathOr, pipe, prop, propEq } from 'ramda';
import InformationCard from '@/modules/shared/components/content/InformationCard';

export default {
	name: 'model-instructions',
	components: { InformationCard },
	computed: {
		...mapState('jobEvaluation', {
			description: pipe(
				pathOr([], ['mainData', 'config', 'stages', 0, 'details']),
				find(propEq('goTo', 'job-supply-guideline-model')),
				prop('instructions'),
			),
		}),
	},
};
</script>

<style lang='scss' scoped>
.content-factors {
	width: 100% !important;
	position: relative !important;
	top: 0 !important;
}
.message {
	border: 1px solid color(orange-dark);
	border-radius: 5px;
	background-color: color(orange-light);
	color: color(white);
	padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/jobs-profile/model-instructions.vue